import React from 'react';
import { Container } from 'react-bootstrap';

const Terms: React.FC = () => {
  return (
    <Container className="py-5">
      <h1 className="fw-bold mb-4">Terms of Use</h1>
      <p className="text-muted">Last updated: {new Date().toLocaleDateString()}</p>
      
      <h3>1. Acceptance of Terms</h3>
      <p>By accessing and using the 515 Soccer Academy website, you accept and agree to be bound by the terms and provision of this agreement.</p>
      
      <h3>2. Use of Site</h3>
      <p>You agree to use this site only for lawful purposes and in a way that does not infringe the rights of, restrict or inhibit anyone else's use and enjoyment of the website.</p>
      
      <h3>3. Intellectual Property</h3>
      <p>All content on this website, including text, graphics, logos, and images, is the property of 515 Soccer Academy and is protected by copyright laws.</p>
      
      <h3>4. Limitation of Liability</h3>
      <p>515 Soccer Academy shall not be liable for any damages arising out of or in connection with the use or inability to use this website.</p>
      
      <h3>5. Changes to Terms</h3>
      <p>We reserve the right to modify these terms at any time. Your continued use of the site after any such changes constitutes your acceptance of the new terms.</p>
    </Container>
  );
};

export default Terms;
